import { render, staticRenderFns } from "./scoring.vue?vue&type=template&id=105752be&scoped=true"
import script from "./scoring.vue?vue&type=script&lang=js"
export * from "./scoring.vue?vue&type=script&lang=js"
import style0 from "./scoring.vue?vue&type=style&index=0&id=105752be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105752be",
  null
  
)

export default component.exports